// ======================================
// Author: Ebenezer Monney
// Copyright (c) 2023 www.ebenmonney.com
// 
// ==> Gun4Hire: contact@ebenmonney.com
// ======================================

export class UserLogin {
    constructor(
      public userName = '',
      public password = '',
      public rememberMe?: boolean
    ) { }
}
  